import React from 'react';
import { getContent, CMS_BASE, title2href } from '../../cms'
import sectionArrow from '../../assets/section_arrow.png';
import './Startpage.scss';

export class Startpage extends React.Component {
  state = {
    cmsBlocks: null
  };

  componentDidMount = async () => {
    const content = await getContent("/home");
    this.setState({ cmsBlocks: content.ContentBlocks });
  }

  render() {
    return (
      <>
        <div className="flex">
          <main>
            {this.state?.cmsBlocks?.map((block, i) => (
              <React.Fragment key={block.Title}>
                <section className="start-section" id={title2href(block.Title)}>
                  <h1>{block.Title}</h1>
                  <video src={CMS_BASE + block?.Video?.url} autoPlay playsInline className="grafik" muted></video>
                  <p className="alpha">
                    {block.Text}
                  </p>
                </section>
                {i !== this.state.cmsBlocks.length - 1 &&
                  <a href={"#" + title2href(this.state.cmsBlocks[i+1].Title)}>
                    <img src={sectionArrow} className="section-arrow" alt="" />
                  </a>
                }
              </React.Fragment>
            ))}
          </main>
        </div>
      </>
    )
  }
}

export default Startpage;